var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42012 9.21318C1.28394 8.99754 1.21584 8.88972 1.17772 8.72342C1.14909 8.5985 1.14909 8.4015 1.17772 8.27658C1.21584 8.11028 1.28394 8.00246 1.42012 7.78682C2.54553 6.00484 5.8954 1.5 11.0004 1.5C16.1054 1.5 19.4553 6.00484 20.5807 7.78682C20.7169 8.00246 20.785 8.11028 20.8231 8.27658C20.8517 8.4015 20.8517 8.5985 20.8231 8.72342C20.785 8.88972 20.7169 8.99754 20.5807 9.21318C19.4553 10.9952 16.1054 15.5 11.0004 15.5C5.8954 15.5 2.54553 10.9952 1.42012 9.21318Z",
    stroke: "#610D24",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 11.5C12.6573 11.5 14.0004 10.1569 14.0004 8.5C14.0004 6.84315 12.6573 5.5 11.0004 5.5C9.34355 5.5 8.0004 6.84315 8.0004 8.5C8.0004 10.1569 9.34355 11.5 11.0004 11.5Z",
    stroke: "#610D24",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.070aac04b82cf89807b4536cb63aa5fc.svg";
export { ForwardRef as ReactComponent };